var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#8C9EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.839 17.655l-6.076-5.968c-.455-.455-1.09-.68-1.724-.684-.006 0-.01-.002-.016-.003h-.001c-.64 0-2.92.228-3.373.68l.664.96-5.111 5.022c-.7.7-1.202 1.764-1.202 2.9V36.54A2.464 2.464 0 0018.46 39h13.126a2.464 2.464 0 002.46-2.46V20.562a4.081 4.081 0 00-1.207-2.908zm-7.816 4.83a2.464 2.464 0 01-2.46-2.462c0-1.292 1.065-2.46 2.46-2.46a2.464 2.464 0 012.461 2.46 2.464 2.464 0 01-2.46 2.461z",
    fill: "#FF641A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.047 36.54V20.563a4.08 4.08 0 00-1.208-2.907l-6.076-5.968c-.455-.455-1.09-.68-1.724-.684-.006 0-.01-.002-.016-.003v6.562a2.464 2.464 0 012.461 2.461 2.464 2.464 0 01-2.46 2.461v16.516h6.562a2.464 2.464 0 002.46-2.461z",
    fill: "#F03800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 33.204c0 .46-.36.82-.82.82h-6.563c-.46 0-.82-.36-.82-.82 0-.46.36-.82.82-.82h6.563c.46 0 .82.36.82.82zM29.125 29.923c0 .46-.36.82-.82.82h-6.563c-.46 0-.82-.36-.82-.82 0-.46.36-.82.82-.82h6.563c.46 0 .82.36.82.82z",
    fill: "#F03800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.023 17.563h-4.921c-1.386 0-2.461-1.175-2.461-2.461a2.464 2.464 0 012.46-2.461h2.212l.977-.96c.453-.453 1.091-.681 1.732-.681h-4.92A4.106 4.106 0 0016 15.102c0 2.198 1.832 4.101 4.102 4.101h4.921a.82.82 0 100-1.64z",
    fill: "#5B362A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.844 18.383a.82.82 0 00-.82-.82v1.64a.82.82 0 00.82-.82z",
    fill: "#38211A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 33.203c0 .46-.36.82-.82.82h-3.282v-1.64h3.282c.46 0 .82.36.82.82zM28.305 30.742h-3.282v-1.64h3.282c.46 0 .82.36.82.82 0 .46-.36.82-.82.82z",
    fill: "#CD0000"
  })));
}
export default "/_next/static/media/budget.0480109dbcbd866069bc5f898f6e9715.svg";
export { SvgBudget as ReactComponent };